<template>
  <div class="tooltip-component">
    <button class="tooltip-target" :class="{ mobile: $isMobile }">?</button>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.tooltip-component {
  padding: 5px;

  .tooltip-target {
    background: $brand-color-1;
    width: 20px;
    height: 20px;
    font-size: 14px;
    color: #fff;
    padding: 0;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:focus {
      outline: none;
    }

    &.mobile {
      background: $brand-color-1;
      width: 24px;
      height: 24px;
      color: #fff;
      border: 1px solid $brand-color-1;
    }
  }
}
</style>

<script>
export default {
  name: "Tooltip",
};
</script>